<template>
  <div class="text-center">
    <div class="spinner-border text-light" role="status">
      <span class="sr-only">Een moment geduld...</span>
    </div>
  </div>
</template>

<script>
export default {
  //
};
</script>
